<template>
    <div class="security">
        <div class="title">
            <div class="title-text">安全监测</div>
        </div>
        <div class="security-box">
            <div class="security-box-left">
                <span>当前园区温度</span>
            </div>
            <ul class="security-box-right">
                <li>
                    <span class="security-box-list1">烟雾监测</span>
                    <span class="security-box-list2">正常</span>
                </li>
                <li>
                    <span class="security-box-list1">漏油监测</span>
                    <span class="security-box-list2">正常</span>
                </li>
                <li>
                    <span class="security-box-list1">异常报警数</span>
                    <span class="security-box-list2" style="color: #ff9600">5</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "security"
    }
</script>

<style scoped lang="less">
    .security{
        width: 90%;
        .security-box{
            display: flex;
            font-family: sy;
            .security-box-left{
                width: 44%;
                height: 11vh;
                background: url("./../../assets/img/security-bg.png") no-repeat;
                background-size: 100% 80%;
                color: white;
                font-size: 12px;
                display: flex;
                justify-content: center;
                align-items: flex-end;
            }
            .security-box-right{
                width: 40%;
                color: white;

                margin: 0;
                margin-left: 4%;
                padding: 0;
                list-style: none;
                margin-top: 6%;
                li{
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                    .security-box-list1{
                        font-size: 12px;
                    }
                    .security-box-list2{
                        font-size: 16px;
                        color:#98fef9;
                    }
                }
            }
        }
    }
</style>